import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.number,
  startTime: PropTypes.string,
  title: PropTypes.string,
  ppv: PropTypes.bool,
  clientId: PropTypes.number,
  clientShortName: PropTypes.string,
  status: PropTypes.string,
  liveStats: PropTypes.bool,
  portalMessage: PropTypes.string,
  team1ClientId: PropTypes.number,
  team2ClientId: PropTypes.number,
  dvr: PropTypes.bool,
  preRollIds: PropTypes.arrayOf(PropTypes.number),
  url: PropTypes.string,
  streamType: PropTypes.string, // Appended; not returned by API
  password: PropTypes.string,
  pwWhenRequired: PropTypes.string,
  pwStreamType: PropTypes.string
});
